var _defs, _polygon, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _polygon2, _g3, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestuarantPos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #010101;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #92d0af;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.1 37.33 27.56 35.28 9.23 49.81 9.82 51.11 32.1 50.87 32.1 37.33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.5,50.87c-1.93-6.12,2.29-12.95,9.48-15.28,4.03-1.31,8.14-.92,11.33.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.14,50.98c-1.99-6.3,2.37-13.36,9.72-15.75,3.98-1.29,8.22-1.01,11.62.77l-.35.67c-3.23-1.69-7.25-1.95-11.04-.72-6.96,2.26-11.1,8.9-9.24,14.81l-.72.23Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.61,20.26c-.21,0-.38-.17-.38-.38,0-2.23-1.52-4.61-3.79-4.61h-5.12c-.21,0-.38-.17-.38-.38s.17-.38.38-.38h5.12c2.72,0,4.55,2.77,4.55,5.36,0,.21-.17.38-.38.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.68,51.48H7.55c-2.64,0-4.79-2.18-4.79-4.85v-27.25c0-2.68,2.15-4.85,4.79-4.85h3.76c.21,0,.38.17.38.38s-.17.38-.38.38h-3.76c-2.23,0-4.04,1.84-4.04,4.1v27.25c0,2.26,1.81,4.1,4.04,4.1h21.13c.21,0,.38.17.38.38s-.17.38-.38.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.05,18.83h-10.47c-2.02,0-3.66-1.64-3.66-3.66s1.64-3.66,3.66-3.66h10.47c2.02,0,3.66,1.64,3.66,3.66s-1.64,3.66-3.66,3.66ZM14.59,12.26c-1.6,0-2.91,1.3-2.91,2.91s1.3,2.91,2.91,2.91h10.47c1.6,0,2.91-1.3,2.91-2.91s-1.3-2.91-2.91-2.91h-10.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.59,25.94h28.24c2.12,0,3.85,1.73,3.85,3.85v14.62H30.74v-14.62c0-2.12,1.73-3.85,3.85-3.85h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.98,62.97h-28.24c-2.12,0-3.85-1.73-3.85-3.85v-14.71h35.94v14.71c0,2.12-1.73,3.85-3.85,3.85h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.52,
    cy: 32.54,
    r: 2.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.52,35.19c-1.46,0-2.64-1.19-2.64-2.64s1.19-2.64,2.64-2.64,2.64,1.19,2.64,2.64-1.19,2.64-2.64,2.64ZM23.52,30.65c-1.04,0-1.89.85-1.89,1.89s.85,1.89,1.89,1.89,1.89-.85,1.89-1.89-.85-1.89-1.89-1.89Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.88,55.18H7.59c-.41,0-.76-.23-.93-.6-.17-.37-.11-.79.15-1.1l2.63-3.07.57.49-2.63,3.07c-.1.12-.06.25-.04.29s.09.16.25.16h23.29v.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.03,63.49c-2.64,0-4.8-2.15-4.8-4.8v-28.57c0-2.64,2.15-4.8,4.8-4.8h27.41c2.64,0,4.8,2.15,4.8,4.8v17.05c0,.21-.17.38-.38.38s-.38-.17-.38-.38v-17.05c0-2.23-1.81-4.05-4.05-4.05h-27.41c-2.23,0-4.05,1.81-4.05,4.05v28.57c0,2.23,1.81,4.05,4.05,4.05.21,0,.38.17.38.38s-.17.38-.38.38Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "53.63 26.09 53.63 35.87 48.64 32.67 43.79 36.11 43.79 26.09 53.63 26.09"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.46,58.34c-.21,0-.38-.17-.38-.38v-6.52c0-.21.17-.38.38-.38s.38.17.38.38v6.52c0,.21-.17.38-.38.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.39 53.94 56.94 54.45 59.46 51.73 61.98 54.45 62.54 53.94 59.46 50.63 56.39 53.94"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.71,63.49h-14.79c-.21,0-.38-.17-.38-.38s.17-.38.38-.38h14.79c.21,0,.38.17.38.38s-.17.38-.38.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestuarantPos);
export default __webpack_public_path__ + "static/media/restuarantPos.1b828d22cfd3c66cf091f4162664eec3.svg";
export { ForwardRef as ReactComponent };